import { Navigate, Outlet } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks';
import { useAuthReady } from '@/hooks/redux';

export default function ProtectedRoute() {
  const isAuthenticated = useIsAuthenticated();
  const authReady = useAuthReady();

  if (!authReady) return null;

  if (!isAuthenticated) return <Navigate to="/auth" />;

  return <Outlet />;
}
